import React from "react";

const pujaImages = [
  { src: "/image/puja/Rudrabhishek1.png", alt: "Rudra Abhishek" },
  { src: "/image/puja/MangalPuja.png", alt: "Mangal Dosh" },
  { src: "/image/puja/DurgaPath.png", alt: "Durga Path" },
  { src: "/image/puja/Rufrabhishek2.png", alt: "Rudra Abhishek" },
  { src: "/image/puja/MangalPuja2.png", alt: "Mangal Dosh" },
];

const PujaGallery = () => {
  return (
    <div className="py-3 ">
      {/* Wrapped in a div with shadow & border for better visibility */}
      <div className="bg-yellow-50 shadow-2xl  border-yellow-300 rounded-sm ">
        <h2 className="text-4xl font-bold text-center text-yellow-800 mb-6 pt-5">
          Puja Photo Gallery
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 px-4 sm:px-28">
          {pujaImages.map((image, index) => (
            <div key={index} className="relative group overflow-hidden rounded-lg shadow-lg bg-yellow-50 flex justify-center items-center p-2 mb-5">
              <img
                src={image.src}
                alt={image.alt}
                className="w-auto max-h-80 object-contain transition-transform duration-300 group-hover:scale-105"
              />
              {/* Puja Name - Appears at Bottom on Hover */}
              <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-70 text-white text-center text-lg font-semibold py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {image.alt}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PujaGallery;
